/*
 * @Author: edvardchen
 * @Date: 2017-11-22 12:05:38
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-07-23 15:35:57
 */

// @flow
import _ from 'lodash';
import { isQbInfoApp, isQQBrowser } from './UA';
import isSelfHostPath from './isSelfHostPath';
import { isomorphicConfig } from './index';

const redirect = (url: string) => {
  window.location.href = url;
};

/**
 * @param  {string} qburl 可能是qb地址或web地址
 * @param  {string} weburl fallback
 */
export default (qburl: string, weburl: string) => {
  let url = qburl;
  if (isSelfHostPath(url)) {
    const host = isomorphicConfig.newsHost || window.location.origin;
    url = `${host}${qburl}`;
  }

  if (url.indexOf('//') === 0) {
    // starts with '//', then add protocal header
    url = `${window.location.protocol}${url}`;
  }

  // 部分场景，比如安卓的视频评论场景，没有特殊UA，只有 reader
  const openUrl = _.get(window, 'browser.app.openUrl');
  if (openUrl) {
    openUrl(
      () => {
        console.log(`openUrl ${url} success`);
      },
      (error) => {
        console.log(`openUrl ${url} failed:`, error);
      },
      {
        url,
        newWindow: 'false',
      },
    );
    return;
  }
  const { userAgent } = window.navigator;
  if (window.reader || isQbInfoApp(userAgent)) {
    const handle = _.get(window, 'browser.coolread.openExternalPage');
    if (handle) {
      handle(url);
      return;
    }
  }
  const target = (!isQQBrowser(userAgent) && weburl) || url;
  redirect(target);
};
